import { render, staticRenderFns } from "./ReportNotification.vue?vue&type=template&id=21122b2e&"
import script from "./ReportNotification.vue?vue&type=script&lang=js&"
export * from "./ReportNotification.vue?vue&type=script&lang=js&"
import style0 from "./ReportNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports